import { z } from 'zod'
import { stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'
import { IPIValidator } from '@App/helpers/validate'

const writersTableSchema = (isExistingWork: boolean, existingWorkHadComposer = true) =>
    z
        .object({
            ['writerName']: z.string(),
            ['writerIPI']: z
                .string()
                .max(11, stringSizeMaxMessage('IPI Number', 11))
                .refine((ipi) => IPIValidator(ipi, false), 'Invalid IPI Number')
                .or(z.literal('--'))
                .optional(),
            ['writerRole']: z.object({
                value: z.string(),
                label: z.string(),
            }),
        })
        .array()
        .min(1, 'At least one writer is required to submit a work registration.')
        .superRefine((val, ctx) => {
            const containsAtLeastOneComposer =
                val.filter((item) => item.writerRole.value === 'C' || item.writerRole.value === 'CA').length > 0

            const canSkipComposerRequirement = isExistingWork && !existingWorkHadComposer

            if (!containsAtLeastOneComposer && !canSkipComposerRequirement) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message:
                        'At least one Composer/Author or Composer writer role is required to submit a work registration.',
                    path: ['_rowError'],
                })
            }
        })

export { writersTableSchema }
